<template>
  <div>
    <div class="endereco-error" v-if="validation">Endereço obrigatório</div>
    <InputMask mask="#####-###" :disabled="acao == '' || desabilitar" label="CEP" v-model="endereco.cep" :validation="validation" @blur="getAddressCep"/> <!-- busca -->
    <Input type="text" readonly :disabled="true" label="Tipo de Logradouro" v-model="endereco.tipologradouro" />
    <BuscaSimplesApi
      label="Nome do Logradouro"
      class="endereco-logradouro"
      :disabled="acao == '' || desabilitar"
      v-model="endereco.nomelogradouro"
      route="gerencial/logradouro"
      fieldSearch="nomelogradouro"
      @found="encontrado"
      :validation="validation" >
      <template slot-scope="slotProps">
        <span>{{ `${slotProps.item.nomelogradouro}, ${slotProps.item.nomebairro} CEP: ${slotProps.item.cep} - ${slotProps.item.nomecidade} / ${slotProps.item.uf}` }}</span>
      </template>
    </BuscaSimplesApi>
    <Input type="text" :disabled="acao == '' || desabilitar" :value="numero" :v="vNumero" @input="e => $emit('update:numero', e)" label="Número do Imóvel"/>
    <Input type="text" :disabled="acao == '' || desabilitar" :value="complemento" :v="vComplemento" @input="e => $emit('update:complemento', e)" label="Complemento"/>
    <Input type="text" readonly :disabled="true" v-model="endereco.nomebairro" label="Bairro"/>
    <Input type="text" readonly :disabled="true" v-model="endereco.nomecidade" label="Cidade"/>
    <Input type="text" readonly :disabled="true" v-model="endereco.uf" label="Estado"/>
  </div>
</template>

<script>
import api from '@/api';
import Input from './Input';
import InputMask from './InputMask';
import BuscaSimplesApi from './BuscaSimplesApi';

const setEnderecoInicial = () => ({
  tipologradouro: '',
  codigologradouro: '',
  nomelogradouro: '',
  cep: '',
  nomebairro: '',
  nomecidade: '',
  uf: '',
});

export default {
  name: 'Endereco',
  props: {
    codigologradouro: [String, Number],
    acao: String,
    complemento: [String, Number],
    numero: [String, Number],
    vNumero: Object,
    vComplemento: Object,
    validation: {
      type: Boolean,
      default: false,
    },
    desabilitar: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Input,
    BuscaSimplesApi,
    InputMask,
  },
  data() {
    return {
      endereco: setEnderecoInicial(),
      buscado: false,
    };
  },
  watch: {
    async codigologradouro(newVal, oldVal) {
      if (this.buscado) {
        this.buscado = false;
        return;
      }

      if (newVal == '') { this.endereco = setEnderecoInicial(); }
        try{
          this.endereco = setEnderecoInicial()
          const { data } = await api.get(`gerencial/logradouro/${this.codigologradouro}`);
          this.endereco = { ...data.results }
        }
        catch(e){
          this.endereco = setEnderecoInicial()
         }
        this.desabilitar = false;
      }
  },
  methods: {
    getAddressCep() {
      this.desabilitar = true;
      if (typeof this.endereco.cep === 'undefined' || this.endereco.cep.length < 8) {
        this.endereco = setEnderecoInicial();
        this.$emit('update:codigologradouro', '');
        return;
      }
      api.get(`gerencial/logradouro?cep=${this.endereco.cep}`).then((response) => {
        if (response.data.results.length > 0) {
          this.endereco = { ...response.data.results[0] };
          this.buscado = true;
          this.$emit('update:codigologradouro', this.endereco.codigologradouro);
        }
      });
    },
    encontrado(dados) {
      this.desabilitar = true;
      this.endereco = setEnderecoInicial();
      this.endereco = { ...dados };
      this.buscado = true;
      this.$emit('update:codigologradouro', this.endereco.codigologradouro);
    },
  },
};
</script>

<style lang="scss">
.endereco-error{
  color: red;
  margin: 4px 0px;
}
.endereco-logradouro{
  width: 60%;
  margin-bottom: 10px;
}
@media only screen and (max-width: 700px){
  .endereco-logradouro{
    width: 100%;
  }
}
</style>
